import { QueryCache } from '@tanstack/react-query';

interface TMeta extends Record<string, unknown> {
  errorMessage: typeof GET_PROFILE_ERRORED | typeof GET_BRANDING_ERRORED;
  handleGetProfileError?: () => void;
}

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: TMeta;
    mutationMeta: TMeta;
  }
}

export const GET_PROFILE_ERRORED = 'GET_PROFILE_ERRORED';
export const GET_BRANDING_ERRORED = 'GET_BRANDING_ERRORED';

export const queryCache = new QueryCache({
  onError: (error, query) => {
    if (query.meta?.errorMessage === GET_PROFILE_ERRORED) {
      const handleError = query.meta.handleGetProfileError;
      return handleError && handleError();
    }

    if (query.meta?.errorMessage === GET_BRANDING_ERRORED) {
      window.location.href = '/404';
    }
  },
});
